import React from "react"
import { Card, CardBody, Col, Media, Row } from "reactstrap"

const SmBasicTile = ({ title, children, handleRemoveWidget }) => {
  return (
    <Col xl={4} xs={12} className="d-flex flex-row flex-grow-1">
      <Card className="mini-stats-wid flex-grow-1">
        <CardBody>
          <Row>
            <Col>
              {!!title && <p className="text-muted fw-medium">{title}</p>}
            </Col>
            <Col xs="auto">
              <i
                className="bx bx-x font-size-22"
                style={{ cursor: "pointer" }}
                onClick={handleRemoveWidget}
              />
            </Col>
          </Row>
          {children}
        </CardBody>
      </Card>
    </Col>
  )
}

export default SmBasicTile
